// ============================================
// DAILY LOGIN TYPE INTERFACES
// ============================================

// Legal KDV oranları (Türkiye: 0/1/10/20). Backend VALID_VAT_PERCENTS
// ile senkron; boş bırakılabilir (adapter branch default'una düşer, ama
// warn logu atar — ops fark eder).
export const LEGAL_VAT_RATES = [0, 1, 10, 20] as const;
export type LegalVatRate = (typeof LEGAL_VAT_RATES)[number];

// Şube bazlı günlük giriş tipi
export interface BranchDailyLoginType {
  id: number;
  branchId: number;
  name: string;
  description?: string;
  price: number;
  voucherTemplateId: number;
  isActive: boolean;
  sortOrder: number;
  // Fiş satır dekompozisyonu ve KDV (bkz. Prisma schema açıklaması):
  vatRate?: number | null;
  productPortionLabel?: string | null;
  productPortionAmount?: number | null;
  productPortionVatRate?: number | null;
  createdAt: string;
  updatedAt: string;
  deletedAt?: string;
  voucherTemplate?: {
    id: number;
    name: string;
    description?: string;
    rewardType?: string;
    validityDays?: number;
    rewardGroups?: {
      id: number;
      name: string;
      rewardQuantity: number;
    }[];
  };
  branch?: {
    id: number;
    name: string;
    companyId: number;
  };
}

// Günlük giriş tipi oluşturma DTO'su
export interface CreateDailyLoginTypeDto {
  name: string;
  description?: string;
  price: number;
  voucherTemplateId: number;
  isActive?: boolean;
  sortOrder?: number;
  vatRate?: number | null;
  productPortionLabel?: string | null;
  productPortionAmount?: number | null;
  productPortionVatRate?: number | null;
}

// Günlük giriş tipi güncelleme DTO'su
export interface UpdateDailyLoginTypeDto {
  name?: string;
  description?: string;
  price?: number;
  voucherTemplateId?: number;
  isActive?: boolean;
  sortOrder?: number;
  vatRate?: number | null;
  productPortionLabel?: string | null;
  productPortionAmount?: number | null;
  productPortionVatRate?: number | null;
}

// Şube kuralları (güncellenmiş yapı)
export interface BranchRulesWithDailyLoginTypes {
  isRulesConfigured: boolean;
  dailyLoginTypes: BranchDailyLoginType[];
  hasDailyLoginTypes: boolean;
}
